module.exports = __webpack_public_path__ + "assets/Girder_Mark-6719b633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Girder_Mark.png
// module id = 422
// module chunks = 0